module.exports = __webpack_public_path__ + "img/illusionist's_cape.edcb7fd1.png";